import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicab() {



const cardData =
{
  keyword: 'Pune to Shirdi Cabs',
  heading: 'Lotus Cab: Pune to Shirdi Cabs',

  headingDescription: 'Lotus Cab offers premium Pune to Shirdi Cabs designed specifically for devotees, families, senior citizens, and group travelers seeking a peaceful and comfortable pilgrimage journey. Shirdi is one of India’s most visited spiritual destinations, and reaching the Sai Baba Samadhi Temple on time is extremely important for darshan and aarti schedules. Our Pune to Shirdi taxi service ensures punctual pickup from any location in Pune including airport, railway station, IT parks, hotels, and residential areas. The route covers approximately 185 km via well-maintained highways, requiring experienced drivers who are familiar with temple rush hours, traffic conditions, and safe long-distance driving. We provide AC sedan and spacious SUV vehicles that are sanitized before every trip and maintained for highway comfort. Whether you are planning a one-way drop, same-day return darshan, overnight stay, or weekend spiritual retreat, Lotus Cab offers flexible travel options. Our transparent pricing structure ensures no hidden charges, clear per kilometer billing, and advance fare estimates. With 24/7 customer support, professional chauffeurs, and clean comfortable cars, Lotus Cab makes your Pune to Shirdi pilgrimage smooth, safe, affordable, and spiritually stress-free.',

  top: 'Top Places to Visit in Shirdi with Lotus Cab',

  "topPlaces": [
    {
      "title": "Sai Baba Samadhi Temple",
      "description": "Sai Baba Samadhi Temple is the spiritual heart of Shirdi and attracts millions of devotees every year. The temple complex includes darshan halls, prayer spaces, and meditation areas where devotees seek blessings and inner peace. Lotus Cab ensures timely arrival for Kakad Aarti, Madhyan Aarti, Dhoop Aarti, and Shej Aarti so that you never miss important rituals. Our drivers are familiar with temple entry routes and parking areas for hassle-free access."
    },
    {
      "title": "Dwarkamai",
      "description": "Dwarkamai is the mosque where Sai Baba lived and spent much of his life guiding devotees. It holds deep spiritual significance and symbolizes unity of faith. Visitors experience calmness and divine energy here."
    },
    {
      "title": "Chavadi",
      "description": "Chavadi is where Sai Baba rested on alternate nights. Devotees visit this sacred site to relive the spiritual history of Shirdi."
    },
    {
      "title": "Gurusthan",
      "description": "Believed to be the place where Sai Baba first appeared, Gurusthan is a peaceful spiritual location visited by devotees seeking blessings."
    },
    {
      "title": "Lendi Baug",
      "description": "A serene garden where Sai Baba meditated daily. It offers a calm and devotional atmosphere."
    },
    {
      "title": "Khandoba Temple",
      "description": "A historic temple associated with Sai Baba’s early days in Shirdi."
    },
    {
      "title": "Sai Heritage Village",
      "description": "Recreates the life and teachings of Sai Baba through detailed exhibits."
    },
    {
      "title": "Sai Teerth Theme Park",
      "description": "A devotional theme park explaining Sai Baba’s life journey in an engaging format."
    },
    {
      "title": "Shani Shingnapur",
      "description": "Located near Shirdi, famous for Lord Shani temple and open-door tradition."
    },
    {
      "title": "Wet N Joy Water Park",
      "description": "A family recreation destination near Shirdi for relaxation after darshan."
    }
  ],

  "services": [
    {
      "name": "Pune to Shirdi Cabs",
      "description": "Lotus Cab provides highly reliable Pune to Shirdi Cabs designed for safe, comfortable, and spiritually fulfilling travel. Our service includes punctual pickup from your doorstep anywhere in Pune, professional highway-experienced drivers, and well-maintained AC vehicles suitable for long-distance travel. Whether you are planning early morning darshan, same-day return trip, or extended pilgrimage stay, we offer flexible departure timing. Our vehicles provide ample luggage space for family travel and comfortable seating for senior citizens. The Pune to Shirdi highway route requires careful and experienced driving, and our chauffeurs are trained for long-distance comfort and safety. Transparent fare structure, no hidden charges, and 24/7 booking assistance make Lotus Cab the preferred choice for pilgrimage travel."
    },
    {
      "name": "Pune to Shirdi Taxi Service",
      "description": "Our Pune to Shirdi Taxi Service ensures smooth long-distance travel with professional drivers who understand temple rush timings and best travel routes. Vehicles are sanitized before every trip and regularly serviced for safety. We provide both sedan and SUV options depending on group size and travel needs. Customers receive clear fare estimates before booking confirmation."
    },
    {
      "name": "Pune to Shirdi One Way Cab",
      "description": "Affordable one-way cab service allowing customers to pay only for drop distance without return fare. Ideal for hotel stays or onward travel plans after darshan."
    },
    {
      "name": "Pune to Shirdi Round Trip Taxi",
      "description": "Flexible round-trip service for same-day darshan or multi-day pilgrimage with customizable return timing and driver coordination."
    },
    {
      "name": "Pune to Shirdi Darshan Cab",
      "description": "Special darshan-focused cab service ensuring punctual temple arrival for aarti schedules and VIP darshan planning."
    },
    {
      "name": "Affordable Pune to Shirdi Cab",
      "description": "Budget-friendly pricing with transparent billing, competitive per km rates, and no hidden charges."
    },
    {
      "name": "Luxury Taxi Pune to Shirdi",
      "description": "Premium luxury sedan and SUV options offering superior comfort, spacious interiors, and executive travel experience."
    },
    {
      "name": "SUV Cab Pune to Shirdi",
      "description": "Spacious SUV vehicles ideal for family pilgrimage and group travel with extra luggage space."
    }
  ],

  "tableData": [
    ["Pune to Shirdi Cabs", "Pune to Shirdi Taxi Service"],
    ["Pune to Shirdi One Way Cab", "Pune to Shirdi Round Trip Taxi"],
    ["Pune to Shirdi Darshan Cab", "Affordable Pune to Shirdi Cab"],
    ["Luxury Taxi Pune to Shirdi", "SUV Cab Pune to Shirdi"],
    ["Cheap Pune to Shirdi Taxi", "Online Pune to Shirdi Cab Booking"],
    ["Best Pune to Shirdi Cab Service", "Pune to Shirdi Sai Baba Temple Cab"],
    ["Pune to Shirdi Family Trip Taxi", ""]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Experienced Pilgrimage Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced in Pune to Shirdi highway travel and understand temple darshan timing importance."
    },
    {
      "WhyChooseheading": "Transparent Pricing Structure",
      "WhyChoosedescription": "Clear per kilometer rates with no hidden fees, ensuring complete fare transparency."
    },
    {
      "WhyChooseheading": "Comfortable AC Vehicles",
      "WhyChoosedescription": "Well-maintained and sanitized AC sedans and SUVs for long-distance comfort."
    },
    {
      "WhyChooseheading": "Flexible One Way & Round Trip",
      "WhyChoosedescription": "Choose travel option based on your convenience and schedule."
    },
    {
      "WhyChooseheading": "24/7 Booking Support",
      "WhyChoosedescription": "Round-the-clock assistance for bookings and trip coordination."
    },
    {
      "WhyChooseheading": "Safe Night Travel",
      "WhyChoosedescription": "Verified drivers ensure secure night highway travel."
    },
    {
      "WhyChooseheading": "Family-Friendly Service",
      "WhyChoosedescription": "Spacious vehicles ideal for senior citizens and group pilgrims."
    },
    {
      "WhyChooseheading": "On-Time Temple Arrival",
      "WhyChoosedescription": "We prioritize punctuality for darshan and aarti schedules."
    }
  ]
}

const faqData = [
  { question: 'Do you provide one-way cab from Pune to Shirdi?', answer: 'Yes, affordable one-way and round-trip options are available with flexible departure timing and transparent pricing.' },
  { question: 'Is darshan cab service available?', answer: 'Yes, we provide darshan-focused travel ensuring punctual arrival at temple.' },
  { question: 'Are SUVs available?', answer: 'Yes, spacious SUV and sedan options available for families.' },
  { question: 'Is pricing transparent?', answer: 'Yes, we follow clear per km billing with no hidden charges.' },
  { question: 'Is night travel safe?', answer: 'Yes, drivers are verified and experienced for highway safety.' },
  { question: 'Can I book online?', answer: 'Yes, online booking available with instant confirmation.' },
  { question: 'Are vehicles AC?', answer: 'Yes, fully air-conditioned vehicles provided.' },
  { question: 'Do you offer family packages?', answer: 'Yes, family pilgrimage packages available.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, recommended during festival seasons.' },
  { question: 'Do you provide corporate travel?', answer: 'Yes, corporate and group bookings available.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Booked Pune to Shirdi cab for family darshan. Driver was punctual, polite, and cooperative. The journey was smooth and comfortable throughout, and we reached temple on time for aarti. Highly recommended for safe pilgrimage travel.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sneha Patil',
    feedback: 'Excellent service for Sai Baba Temple visit. Transparent pricing, clean vehicle, and safe driving made our trip peaceful and stress-free. Lotus Cab truly offers reliable pilgrimage travel.',
    rating: 5
  }
];













































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-shirdi-cabs.jpg", 
  "description": "Lotus Cab offers Pune to Shirdi cabs with affordable one way and round trip taxi service. Book sedan, SUV and luxury cabs for Shirdi Sai Baba darshan, family trips and comfortable outstation travel with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7000"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3299",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-shirdi-cabs"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Pune to Shirdi Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Shirdi cabs with Lotus Cab. Affordable one way & round trip taxi for Sai Baba darshan & family trips. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Shirdi Cabs, Pune to Shirdi Taxi Service, Pune to Shirdi One Way Cab, Pune to Shirdi Round Trip Taxi, Pune to Shirdi Darshan Cab, Affordable Pune to Shirdi Cab, Luxury Taxi Pune to Shirdi, SUV Cab Pune to Shirdi, Cheap Pune to Shirdi Taxi, Online Pune to Shirdi Cab Booking, Best Pune to Shirdi Cab Service, Pune to Shirdi Sai Baba Temple Cab, Pune to Shirdi Family Trip Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdicab;